export default "/assets/pescatarian.svg";